import React from 'react';
import { compose } from 'react-apollo';
import { getUserData } from 'utils/graphQLFunctions';
import HomepageButton from '../../HomepageButton';
import './VisitBanner.css';

const VisitBanner = ({ userData }) => {
  const preferredLocation = userData?.user?.preferredLocation;

  return (
    <div className="visit-banner-wrapper">
      <div className="visit-banner-panel">
        <div className="visit-banner-sub-title">Visit Us</div>
        <div className="visit-banner-title">Your rewards are calling!</div>
        <div className="visit-banner-content">
          Use your rewards {preferredLocation && `at ${preferredLocation}`}{' '}
          before they expire. Come visit us!
        </div>
        <a
          title={preferredLocation}
          href={`https://windcreek.com/${preferredLocation}`}
        >
          <HomepageButton title="Book a Stay" />
        </a>
      </div>
    </div>
  );
};

export default compose(
  getUserData({
    name: 'userData'
  })
)(VisitBanner);
